import { addDays, format, isToday, isYesterday, parseISO, startOfDay } from 'date-fns'
import { fr } from 'date-fns/locale'

/** Date du jour en YYYY-MM-DD, fuseau local (pas UTC). */
export function todayISO() {
  return format(new Date(), 'yyyy-MM-dd')
}

/** Date décalée de `days` jours, toujours en fuseau local. */
export function shiftDaysISO(days) {
  return format(addDays(new Date(), days), 'yyyy-MM-dd')
}

/** Interprète une date API (YYYY-MM-DD ou ISO) comme date locale. */
export function parseLocalDate(value) {
  const iso = String(value || '').split('T')[0]
  return startOfDay(parseISO(iso))
}

export function formatLocalISO(value) {
  return format(parseLocalDate(value), 'yyyy-MM-dd')
}

export function formatOperationDayLabel(value) {
  const date = parseLocalDate(value)
  if (isToday(date)) return { key: 'today', label: 'Aujourd’hui', date }
  if (isYesterday(date)) return { key: 'yesterday', label: 'Hier', date }
  return {
    key: format(date, 'yyyy-MM-dd'),
    label: format(date, 'EEEE d MMMM', { locale: fr }),
    date,
  }
}

export function formatOperationLongDate(value, { weekday = false } = {}) {
  return parseLocalDate(value).toLocaleDateString('fr-FR', {
    ...(weekday ? { weekday: 'long' } : {}),
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}
